export default __webpack_public_path__ + "static/media/success-browser.e534b680.svg";